import { Text, Radio, Group, UnstyledButton } from '@mantine/core';
import { Dispatch, ReactNode, SetStateAction } from 'react';
import classes from './RadioContainer.module.css';

interface RadioContainerProps {
  radioId: string;
  leftText: ReactNode | string;
  rightText?: ReactNode | string;
  setOption: Dispatch<SetStateAction<string>>;
  disabled?: boolean;
  selectedOption?: string;
  showRadioButton?: boolean;
  hasError?: boolean;
  testId?: string;
}

export const RadioContainer = ({
  radioId,
  leftText,
  rightText,
  setOption,
  disabled,
  selectedOption,
  showRadioButton = true,
  hasError = false,
  testId,
}: RadioContainerProps) => {
  const isSelected = radioId === selectedOption;

  const selectedColor = isSelected ? 'var(--mantine-primary-color-filled)' : 'var(--mantine-color-dimmed)';

  return (
    <UnstyledButton
      className={isSelected ? `${classes.radioContainer} ${classes.radioContainerSelected}` : classes.radioContainer}
      disabled={disabled}
      px={14}
      my={5}
      h={40}
      onClick={() => setOption(radioId)}
      w={'100%'}
      data-testid={`radio-box-${testId?.replaceAll(' ', '-')}`}
    >
      <Group justify={'space-between'}>
        <Text c={hasError ? 'var(--mantine-color-error)' : selectedColor} fw={isSelected ? 600 : 500}>
          {leftText}
        </Text>
        <Group>
          <Text component={'span'} c={hasError ? 'var(--mantine-color-error)' : ''}>
            {rightText}
          </Text>
          {showRadioButton && <Radio key={radioId} checked={isSelected} readOnly />}
        </Group>
      </Group>
    </UnstyledButton>
  );
};
